module.exports = __webpack_public_path__ + "static/Logo-Imagemaker-2020-b62286b3254258a801959bcbe08ff9e5.jpg";